import { useCallback, useMemo, useState } from "react";
import { Upload, Spin, Image, Popconfirm, Button } from "antd";
import { useTranslation } from "react-i18next";
import {
  InboxOutlined,
  LoadingOutlined,
  DeleteOutlined,
} from "@ant-design/icons";
import { getBase64, getDimensions } from "utils/helper";
import { createUploadRequest } from "utils/uploadRequest";
import { deletePhotoById, deleteTemporaryPhoto } from "apis/contact";
import { useAntdMessage } from "hooks/useAntdMessage";

const UploadImage = ({
  imageUrlForm,
  mimeType = "image/jpeg, image/png",
  name = "photo",
  action = "/WA/contacts/photo",
  maxHeight = 9000,
  maxWeight = 10,
  maxWidth = 9000,
  photoHandler,
  id,
  photoFromData,
}) => {
  const { t } = useTranslation();
  const { message } = useAntdMessage();
  const [imageUrl, setImageUrl] = useState(imageUrlForm || "");
  const [loading, setLoading] = useState(false);

  const uploadRequest = useMemo(() => createUploadRequest(action), [action]);
  // useEffect(() => {
  //   setImageUrl(imageProfileUrl);
  // }, [imageProfileUrl]);

  const changeHandler = useCallback(
    async ({ file }) => {
      const temp = await getBase64(file.originFileObj);
      photoHandler(temp);
      setImageUrl(temp);

      if (file.status === "uploading") {
        setLoading(true);
        return;
      }
      if (file.status === "done") {
        message.success(
          `${file.name} ${t("property.file_uploaded_successfully")}`
        );
        // const filePreview = await getBase64(file.originFileObj);
        // setImageUrl(filePreview);
        photoHandler(file.response?.data);
        setImageUrl(file.response?.data);
        // console.log(file);
        // dispatch(editUser({ profile_image: filePreview }));
        setLoading(false);
      } else if (file.status === "error") {
        photoHandler("");
        setImageUrl("");
        message.error(`${file.name} ${t("property.file_upload_failed")}`);
        setLoading(false);
      }
    },
    [t, photoHandler, message]
  );

  const beforeUploadHandler = useCallback(
    async (file) => {
      const isJpgOrPng = mimeType.includes(file.type);
      if (!isJpgOrPng) {
        message.error(t("property.you_can_only_upload_jpg_or_png_file_"));
      }
      const isLt1M = file.size / 1024 / 1024 <= maxWeight;
      if (!isLt1M) {
        message.error(
          `${t("property.image_must_smaller_than")} ${maxWeight}MB!`
        );
      }

      let isMaxWidth = false;
      let isMaxHeight = false;
      const dimensions = await getDimensions(file);
      if (dimensions) {
        isMaxWidth = dimensions.width <= maxWidth;
        if (!isMaxWidth) {
          message.error(
            `${t("property.image_width_must_smaller_than")} ${maxWidth}px!`
          );
        }

        isMaxHeight = dimensions.height <= maxHeight;
        if (!isMaxHeight) {
          message.error(
            `${t("property.image_height_must_smaller_than")} ${maxHeight}px!`
          );
        }
      }

      return new Promise((resolve, reject) => {
        if (isJpgOrPng && isLt1M && isMaxWidth && isMaxHeight) {
          return resolve(true);
        }
        return reject;
      });
    },
    [maxHeight, maxWeight, maxWidth, mimeType, t, message]
  );
  const deleteImageUrl = async () => {
    setLoading(true);
    try {
      let response;
      if (photoFromData) {
        response = await deletePhotoById(imageUrl, id);
      } else response = await deleteTemporaryPhoto(imageUrl);
      if (response?.data?.success) {
        message.success(response.data.message);
        setLoading(false);
        photoHandler("");
        setImageUrl("");
        // onSuccessDelete()
      } else {
        message.error(
          response?.data?.message //??
          // intl.formatMessage({ id: 'financeProduct.cannot_delete_current_photo' }),
        );
        setLoading(false);
      }
    } catch (error) {
      message.error(t("delete_photo_failed"));
      setLoading(false);
    }
  };

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-5 ">
      <div className="">
        <Upload.Dragger
          accept={mimeType}
          name={name}
          showUploadList={false}
          customRequest={uploadRequest}
          beforeUpload={beforeUploadHandler}
          onChange={changeHandler}
        >
          <div>
            <p className="ant-upload-drag-icon">
              {loading ? <LoadingOutlined /> : <InboxOutlined />}
            </p>
            <p className="ant-upload-text text-center text-sm ">
              {t("property.click_or_drag_file_to_this_area_to_upload")}
            </p>
            <div className="ant-upload-hint mt-2">
              <ul
                style={{ textAlign: "left" }}
                className="list-disc pl-4 text-xs"
              >
                <li>
                  {t("property.image_file_size_maximal")} {maxWeight} MB
                </li>
                {/* <li>
                  {t("property.image_file_dimension_maximal")} {maxWidth}px *{" "}
                  {maxHeight}px
                </li> */}
              </ul>
            </div>
          </div>
        </Upload.Dragger>
      </div>
      {imageUrl && (
        <div className="col-md-6">
          <h6 className="text-center font-semibold">{t("property.preview")}</h6>
          <Spin spinning={loading}>
            <div
              style={{
                padding: 5,
                border: "1px solid #d9d9d9",
                borderRadius: 4,
                //   width: isMobileView ? '100%' : 220,
                margin: "0 auto",
                position: "relative",
              }}
            >
              <Image
                style={{ width: "100%", borderRadius: 4 }}
                src={imageUrl}
                alt="Photo"
              />
              <Popconfirm
                title={"Apakah Anda yakin untuk menghapus?"}
                onConfirm={deleteImageUrl}
                okText={"Ya"}
                cancelText={"Batal"}
              >
                <Button
                  style={{ position: "absolute", top: 10, right: 10 }}
                  type="primary"
                  danger
                  shape="circle"
                  icon={<DeleteOutlined />}
                  size="small"
                />
              </Popconfirm>
            </div>
          </Spin>
        </div>
      )}
    </div>
  );
};

export default UploadImage;
